export function CoreEmailDirective () {
  return {
    link (scope, element, attrs, ctrl) {
      const regex = /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9-]+(\.[a-z0-9-]+)*$/i;

      ctrl.$parsers.push(value => {
        if ( !value || (value && value.match(regex)) ) {
          ctrl.$setValidity('email', true);

          return value;
        }

        ctrl.$setValidity('email', false);

        return value;
      });
    },
    restrict: 'A',
    require : 'ngModel'
  };
}